import moment from 'moment';

export const getLink = event => `/events/${event.name}`;

export const hasConcluded = event => event && event.end && moment(event.end).isBefore(moment());

export const isEvergreen = event => event && !event.start && !event.end;

export const isOngoing = event => event &&
	event.start && (!event.end || moment().isBefore(event.end));

export const compareStart = (a, b) => {
	if (a && a.start) {
		if (b && b.start) {
			if (moment(a.start).isBefore(moment(b.start))) {
				return -1;
			}
			if (moment(b.start).isBefore(moment(a.start))) {
				return 1;
			}
			return 0;
		}
		return 1;
	}
	if (b && b.start) {
		return -1;
	}
	return 0;
};
